/**
 * 登出弹出层
 */

import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang/index';
import Modal from 'boron/ScaleModal';


const noop = function(){};

const style = {
    modalStyle: {
        position: 'absolute',
         width: '320px'
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        position: 'absolute',
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class OverlayPop  extends Component {
    static defaultProps = {
        onHide: noop,
        onConfirm: noop,
        onCancel: noop,
        type: 'confirm',
        closeOnClick: true
    }
    constructor(props){
        super(props);

        this.status = 'cancel';
    }

    onConfirm() {
        this.hideModal();
        this.status = 'confirm';
    }

    onCancel() {
        this.hideModal();
        this.status = 'cancel';
    }

    onHide() {
        if (this.status == 'confirm') {
            this.props.onConfirm();
        } else {
            this.props.onCancel();
        }

        this.props.onHide();
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }
    
    render() {
        let modalStyle = style.modalStyle;
        let backdropStyle = style.backdropStyle;
        let contentStyle = style.contentStyle;
        
        if (this.props.modalStyle) {
            for (let style in this.props.modalStyle) {
                modalStyle[style] = this.props.modalStyle[style];
            }
        }

        if (this.props.backdropStyle) {
            for (let style in this.props.backdropStyle) {
                backdropStyle[style] = this.props.backdropStyle[style];
            }
        }

        if (this.props.contentStyle) {
            for (let style in this.props.contentStyle) {
                contentStyle[style] = this.props.contentStyle[style];
            }
        }

        return (
            <Modal 
                ref="modal" 
                closeOnClick={this.props.closeOnClick}
                modalStyle={modalStyle}  
                backdropStyle={backdropStyle} 
                contentStyle={contentStyle}
                onHide={this.onHide.bind(this)}
            >
                <div className="overlay-pop">
                    <div className="overlay-pop-bd">
                        <div className="overlay-pop-hd">{lang.template('提示')}</div>
                        <div className="apply-confirm-bd">
                            { lang.template('您的账号在其他终端登录成功') }
                        </div>
                    </div>
                    <div className="overlay-pop-ft">
                        <button className="btn cancel" onClick={()=>this.onCancel()}>{lang.template('知道了')}</button>
                        <button className="btn confirm" onClick={()=>this.onConfirm()}>{lang.template('重新登录')}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default OverlayPop;


// WEBPACK FOOTER //
// ./js/im/views/offline-confirm.js